import { AccountPlatformFeatureProvider } from 'components/account-platform-features/context';
import React from 'react';
import { Header, Divider } from 'semantic';
import {
  TariffProfileScanToPayTariff,
  TariffProfile,
} from 'types/tariffprofile';
import { TariffProfileFeatureProvider } from './TariffProfileFeatureProvider';
import { useUser } from 'contexts/user';
import { set } from 'lodash';
import { useTranslation } from 'react-i18next';
import { TariffCostSettings } from './TariffCostSettings';

interface ScanToPayTariffProps {
  formValues: TariffProfile;
  onChange: (next: TariffProfileScanToPayTariff) => void;
  sameForAcDc: boolean;
}

export default function ScanToPayTariff({
  formValues,
  onChange,
  sameForAcDc,
}: ScanToPayTariffProps) {
  const { user } = useUser();
  const { t } = useTranslation();

  formValues.scanToPayTariff ??= {
    costSettings: {
      ac: {
        pricePerSession: 0,
        pricePerHour: 0,
        pricePerKwh: 0,
      },
      dc: {
        pricePerSession: 0,
        pricePerHour: 0,
        pricePerKwh: 0,
      },
    },
  };

  const setField =
    (tariff: TariffProfileScanToPayTariff) => (field: string, value: any) => {
      set(tariff, field, value);
      onChange(tariff);
    };

  type Selected = {
    ac: string;
    dc: string;
  };

  const setActiveTariffSystem =
    (tariff: TariffProfileScanToPayTariff) => (e: Selected) => {
      if (e.ac !== 'scheduled') {
        tariff.costSettings.ac.components = [];
      }

      if (e.dc !== 'scheduled') {
        tariff.costSettings.dc.components = [];
      }

      tariff.costSettings.ac.enableEnergyMarketTracking = e.ac === 'dynamic';
      tariff.costSettings.dc.enableEnergyMarketTracking = e.dc === 'dynamic';

      if (e.ac !== 'dynamic') {
        tariff.costSettings.ac.surchargePerKwh = 0;
      }

      if (e.dc !== 'dynamic') {
        tariff.costSettings.dc.surchargePerKwh = 0;
      }
    };

  if (!user) {
    return <></>;
  }

  return (
    <React.Fragment>
      <Header style={{ marginTop: '2rem' }}>
        {t('scanToPayTariff.customTariff', 'Custom Tariff for Scan-To-Pay')}
      </Header>
      <div
        style={{
          border: 'rgba(29, 31, 33, 0.1) solid 1px',
          padding: 10,
          marginBottom: 15,
          borderRadius: '.25rem',
        }}>
        <h4
          style={{
            margin: 'auto 0',
          }}>
          AC/DC
        </h4>
        <Divider hidden />
        <AccountPlatformFeatureProvider accountId={user.accountId}>
          <TariffProfileFeatureProvider>
            <TariffCostSettings
              sameForAcDc={sameForAcDc}
              formValues={{
                ...formValues,
                costSettings: formValues.scanToPayTariff?.costSettings,
              }}
              setField={setField(formValues.scanToPayTariff)}
              setActiveTariffSystem={setActiveTariffSystem(
                formValues.scanToPayTariff
              )}
              hideHeader={true}
            />
          </TariffProfileFeatureProvider>
        </AccountPlatformFeatureProvider>
      </div>
    </React.Fragment>
  );
}
